import { SaleProduct, SaleTotals } from '../../../types/sale';

export const normalizeSaleProductAmounts = (
  product: SaleProduct
): SaleProduct => ({
  ...product,
  tourismTaxRate: product.tourismTaxRate ?? 0,
  tourismTaxAmount: product.tourismTaxAmount ?? 0,
  tipPercentageApplied: product.tipPercentageApplied ?? 0,
  tipAmount: product.tipAmount ?? 0,
});

export const normalizeSaleProducts = (products?: SaleProduct[]) =>
  (products ?? []).map(normalizeSaleProductAmounts);

export const normalizeSaleTotals = (totals?: SaleTotals): SaleTotals => ({
  ...(totals ?? {}),
  totalTourismTax: totals?.totalTourismTax ?? 0,
  totalTip: totals?.totalTip ?? 0,
});

export const getBackendTipTotal = (
  products: SaleProduct[],
  totals?: SaleTotals
) => {
  if (totals?.totalTip != null) return Number(totals.totalTip);

  return products.reduce(
    (total, product) => total + Number(product.tipAmount ?? 0),
    0
  );
};
